// src/api.js
import axios from "axios";
import { toast } from "react-toastify";
import i18n from "i18next";

let onAccessDenied = null;
export function setOnAccessDenied(fn) {
  onAccessDenied = fn;
}

const REDIRECT_LOCK_KEY = "redirectingToLogin";
function hasRedirectLock() {
  return sessionStorage.getItem(REDIRECT_LOCK_KEY) === "1";
}
function setRedirectLock() {
  sessionStorage.setItem(REDIRECT_LOCK_KEY, "1");
}
export function resetLoginRedirectLock() {
  sessionStorage.removeItem(REDIRECT_LOCK_KEY);
}

const TOAST_ID_SESSION_EXPIRED = "session-expired-toast";
function showSessionExpiredToast() {
  const msg =
    (i18n && typeof i18n.t === "function" && i18n.t("auth.sessionExpired")) ||
    "Votre session a expiré. Veuillez vous reconnecter.";
  if (!toast.isActive(TOAST_ID_SESSION_EXPIRED)) {
    toast.error(msg, { toastId: TOAST_ID_SESSION_EXPIRED });
  }
}

const api = axios.create({
  baseURL: process.env.REACT_APP_API_URL || "http://localhost:8080",
  withCredentials: true, // laisse à true si tu utilises des cookies httpOnly
});

api.interceptors.request.use((config) => {
  const token = localStorage.getItem("token");
  if (token) {
    config.headers = config.headers || {};
    config.headers.Authorization = `Bearer ${token}`;
  }
  return config;
});

api.interceptors.response.use(
  (res) => res,
  (err) => {
    const status = err?.response?.status;

    const isSessionExpired =
      status === 401 || // Unauthorized
      status === 419 || // CSRF/session expired (certains frameworks)
      status === 440 || // Login Timeout (IIS)
      status === 498;   // Invalid/expired token (certains APIs)

    // Un 401 sur l'endpoint de login = mauvais identifiants, pas une session expirée
    const isLoginEndpoint = err?.config?.url?.includes("/auth/login");

    if (isSessionExpired && !isLoginEndpoint) {
      localStorage.removeItem("token");
      localStorage.removeItem("user");

      showSessionExpiredToast();

      if (!hasRedirectLock()) {
        const { pathname, search } = window.location;
        const next = encodeURIComponent(`${pathname}${search || ""}`);

        setRedirectLock();
        setTimeout(() => {
          window.location.assign(`/login?next=${next}`);
        }, 600);
      }
    }

    // Organisation suspendue par le superadmin : message clair et persistant.
    const msg = err?.response?.data?.message || err?.response?.data?.error || "";
    if (status === 403 && /suspendue|suspended/i.test(msg)) {
      if (!toast.isActive("org-suspended")) {
        toast.error(msg, { toastId: "org-suspended", autoClose: false });
      }
    } else if (status === 403 && onAccessDenied) {
      onAccessDenied();
    }

    return Promise.reject(err);
  }
);

export default api;
